"use client";

import { useEffect } from "react";

export default function SanityConsoleGuard() {
  useEffect(() => {
    const origConsoleError = console.error.bind(console);

    console.error = (...args) => {
      try {
        const first = args[0];
        const text =
          typeof first === "string" ? first : JSON.stringify(first || "");

        if (
          text.includes("Failed to fetch version for package") ||
          text.includes("fetchLatestAvailableVersionForPackage") ||
          text.includes("registry.npmjs.org") ||
          (args[1] &&
            args[1] instanceof Error &&
            args[1].message &&
            args[1].message.includes("Failed to fetch"))
        ) {
          return; 
        }
      } catch (err) {
      }

      origConsoleError(...args);
    };

    return () => {
      console.error = origConsoleError;
    };
  }, []);

  return null;
}
